module.exports = __webpack_public_path__ + "e1b6caf3f225249c81d7da53546844e6.png";